import React, { useState, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import PageHero from '../components/PageHero';
import './pages.css';
import './Gallery.css';

// ── Fansipan ──────────────────────────────────────────────────────────────────
import AboveTheClouds  from '../images/Gallery/Fansipan - Above the Clouds.jpg';
import CloudRide       from '../images/Gallery/Fansipan - Cloud Ride.jpg';
import ThroughTheMist  from '../images/Gallery/Fansipan - Through the Mist.jpg';
import AtTheSummit     from '../images/Gallery/Fansipan - At the Summit.jpg';
import FlagsOnHigh     from '../images/Gallery/Fansipan - Flags on High.jpg';

// ── Sa Pa — Bridal ────────────────────────────────────────────────────────────
import FlagStreet      from '../images/Gallery/Sa Pa - Flag Street.jpg';
import TheLobby        from '../images/Gallery/Sa Pa - The Lobby.jpg';
import TownSquare      from '../images/Gallery/Sa Pa - Town Square.jpg';
import SaPaPlaza       from '../images/Gallery/Sa Pa - Sa Pa Plaza.jpg';
import StoneChurch     from '../images/Gallery/Sa Pa - Stone Church.jpg';
import TheConservatory from '../images/Gallery/Sa Pa - The Conservatory.jpg';
import RedBroomMarket  from '../images/Gallery/Sa Pa - Red Broom Market.jpg';
import RedBroomShop    from '../images/Gallery/Sa Pa - Red Broom Shop.jpg';
import SucculentWall   from '../images/Gallery/Sa Pa - Succulent Wall.jpg';
import MaigoldFields   from '../images/Gallery/Sa Pa - Marigold Fields.jpg';
import MistyAvenue     from '../images/Gallery/Sa Pa - Misty Avenue.jpg';

// ── Sa Pa — Night ─────────────────────────────────────────────────────────────
import RedNight        from '../images/Gallery/Sa Pa - Red Night.jpg';
import MidnightFog     from '../images/Gallery/Sa Pa - Midnight Fog.jpg';

// ── Hanoi ─────────────────────────────────────────────────────────────────────
import OldQuarterAlley from '../images/Gallery/Hanoi - Old Quarter Alley.jpg';
import PeachBlossoms   from '../images/Gallery/Hanoi - Peach Blossoms.jpg';
import StreetBar       from '../images/Gallery/Hanoi - Street Bar.jpg';
import TheConversation from '../images/Gallery/Hanoi - The Conversation.jpg';
import FlagTunnel      from '../images/Gallery/Hanoi - Flag Tunnel.jpg';

// ── Thumbnails (600px — used in grid tiles and filmstrip) ─────────────────────
import AboveTheCloudsThumb  from '../images/Gallery/thumb/Fansipan - Above the Clouds.jpg';
import CloudRideThumb       from '../images/Gallery/thumb/Fansipan - Cloud Ride.jpg';
import ThroughTheMistThumb  from '../images/Gallery/thumb/Fansipan - Through the Mist.jpg';
import AtTheSummitThumb     from '../images/Gallery/thumb/Fansipan - At the Summit.jpg';
import FlagsOnHighThumb     from '../images/Gallery/thumb/Fansipan - Flags on High.jpg';
import FlagStreetThumb      from '../images/Gallery/thumb/Sa Pa - Flag Street.jpg';
import TheLobbyThumb        from '../images/Gallery/thumb/Sa Pa - The Lobby.jpg';
import TownSquareThumb      from '../images/Gallery/thumb/Sa Pa - Town Square.jpg';
import SaPaPlazaThumb       from '../images/Gallery/thumb/Sa Pa - Sa Pa Plaza.jpg';
import StoneChurchThumb     from '../images/Gallery/thumb/Sa Pa - Stone Church.jpg';
import TheConservatoryThumb from '../images/Gallery/thumb/Sa Pa - The Conservatory.jpg';
import RedBroomMarketThumb  from '../images/Gallery/thumb/Sa Pa - Red Broom Market.jpg';
import RedBroomShopThumb    from '../images/Gallery/thumb/Sa Pa - Red Broom Shop.jpg';
import SucculentWallThumb   from '../images/Gallery/thumb/Sa Pa - Succulent Wall.jpg';
import MaigoldFieldsThumb   from '../images/Gallery/thumb/Sa Pa - Marigold Fields.jpg';
import MistyAvenueThumb     from '../images/Gallery/thumb/Sa Pa - Misty Avenue.jpg';
import RedNightThumb        from '../images/Gallery/thumb/Sa Pa - Red Night.jpg';
import MidnightFogThumb     from '../images/Gallery/thumb/Sa Pa - Midnight Fog.jpg';
import OldQuarterAlleyThumb from '../images/Gallery/thumb/Hanoi - Old Quarter Alley.jpg';
import PeachBlossomsThumb   from '../images/Gallery/thumb/Hanoi - Peach Blossoms.jpg';
import StreetBarThumb       from '../images/Gallery/thumb/Hanoi - Street Bar.jpg';
import TheConversationThumb from '../images/Gallery/thumb/Hanoi - The Conversation.jpg';
import FlagTunnelThumb      from '../images/Gallery/thumb/Hanoi - Flag Tunnel.jpg';

// Photo list — ordered to mix categories across grid rows
const photos = [
  { src: FlagStreet,       thumb: FlagStreetThumb,       alt: 'Couple walking through a misty Sa Pa market lined with Vietnamese flags',          category: 'Bridal',   title: 'Flag Street'        },
  { src: AboveTheClouds,   thumb: AboveTheCloudsThumb,   alt: 'Couple inside the Fansipan cable car gondola above the clouds',                    category: 'Fansipan', title: 'Above the Clouds'   },
  { src: OldQuarterAlley,  thumb: OldQuarterAlleyThumb,  alt: 'Couple walking hand-in-hand through a narrow Hanoi alley',                         category: 'Hanoi',    title: 'Old Quarter Alley'  },
  { src: TheLobby,         thumb: TheLobbyThumb,         alt: 'Bride on a hotel luggage cart, groom standing in a moody corridor',                category: 'Bridal',   title: 'The Lobby'          },
  { src: ThroughTheMist,   thumb: ThroughTheMistThumb,   alt: 'Couple silhouetted in thick fog under bunting flags at a plaza',                   category: 'Fansipan', title: 'Through the Mist'   },
  { src: TheConversation,  thumb: TheConversationThumb,  alt: 'Couple facing each other in a warm golden misty corridor in Hanoi',                category: 'Hanoi',    title: 'The Conversation'   },
  { src: PeachBlossoms,    thumb: PeachBlossomsThumb,    alt: 'Couple embracing in a pink peach blossom garden in Hanoi',                         category: 'Hanoi',    title: 'Peach Blossoms'     },
  { src: TheConservatory,  thumb: TheConservatoryThumb,  alt: 'Couple standing in a misty glass conservatory with ornate iron gates in Sa Pa',    category: 'Bridal',   title: 'The Conservatory'   },
  { src: TownSquare,       thumb: TownSquareThumb,       alt: 'Couple running joyfully in front of a European-style building in Sa Pa',           category: 'Bridal',   title: 'Town Square'        },
  { src: CloudRide,        thumb: CloudRideThumb,        alt: 'Couple sitting in cable car with mountain clouds visible outside',                  category: 'Fansipan', title: 'Cloud Ride'         },
  { src: RedBroomMarket,   thumb: RedBroomMarketThumb,   alt: 'Couple sitting in a traditional Sa Pa shop surrounded by hanging red brooms',      category: 'Bridal',   title: 'Red Broom Market'   },
  { src: StreetBar,        thumb: StreetBarThumb,        alt: 'Couple standing in front of a red-shuttered bar on a Hanoi street',                category: 'Hanoi',    title: 'Street Bar'         },
  { src: RedBroomShop,     thumb: RedBroomShopThumb,     alt: 'Couple standing dramatically in a Sa Pa shop filled with red brooms and dried corn', category: 'Bridal', title: 'Red Broom Shop'     },
  { src: StoneChurch,      thumb: StoneChurchThumb,      alt: 'Groom walking toward bride standing at the entrance of Sa Pa Stone Church',        category: 'Bridal',   title: 'Stone Church'       },
  { src: SucculentWall,    thumb: SucculentWallThumb,    alt: 'Couple leaning against a lush succulent garden wall in Sa Pa',                     category: 'Bridal',   title: 'Succulent Wall'     },
  { src: AtTheSummit,      thumb: AtTheSummitThumb,      alt: 'Couple waving Vietnamese flags at the Fansipan 3143m summit marker in the fog',   category: 'Fansipan', title: 'At the Summit'      },
  { src: FlagTunnel,       thumb: FlagTunnelThumb,       alt: 'Couple dancing joyfully through a tunnel of colorful hanging flags in Hanoi',      category: 'Hanoi',    title: 'Flag Tunnel'        },
  { src: FlagsOnHigh,      thumb: FlagsOnHighThumb,      alt: 'Couple holding Vietnamese flags high against a clear blue sky at Fansipan summit', category: 'Fansipan', title: 'Flags on High'      },
  { src: MaigoldFields,    thumb: MaigoldFieldsThumb,    alt: 'Couple in a misty Sa Pa marigold field, mountains fading into the fog behind them', category: 'Bridal',  title: 'Marigold Fields'    },
  { src: RedNight,         thumb: RedNightThumb,         alt: 'Woman in red beret glancing back through warm orange Sa Pa fog at night',          category: 'Night',    title: 'Red Night'          },
  { src: SaPaPlaza,        thumb: SaPaPlazaThumb,        alt: 'Couple holding hands in a wide open Sa Pa plaza with bare trees',                  category: 'Bridal',   title: 'Sa Pa Plaza'        },
  { src: MistyAvenue,      thumb: MistyAvenueThumb,      alt: 'Bride and groom running hand-in-hand down a misty Sa Pa avenue at dusk',          category: 'Bridal',   title: 'Misty Avenue'       },
  { src: MidnightFog,      thumb: MidnightFogThumb,      alt: 'Couple on a foggy Sa Pa street at night, car headlights piercing the mist',       category: 'Night',    title: 'Midnight Fog'       },
];

// Filter categories — order reflects the site's story arc
const CATEGORIES = ['All', 'Fansipan', 'Bridal', 'Night', 'Hanoi'];

const Gallery = () => {
  const [lightbox, setLightbox]             = useState(null);
  const [activeCategory, setActiveCategory] = useState('All');
  const thumbStripRef = useRef(null);
  const touchStartX   = useRef(null);

  const filteredPhotos = activeCategory === 'All'
    ? photos
    : photos.filter(p => p.category === activeCategory);

  // Scroll-reveal: re-run observer whenever the filtered list changes
  useEffect(() => {
    const items = document.querySelectorAll('.gallery-item');
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('gallery-item--visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }
    );
    items.forEach(item => observer.observe(item));
    return () => observer.disconnect();
  }, [activeCategory]);

  // Lock scroll on both html and body while viewer is open
  useEffect(() => {
    const val = lightbox !== null ? 'hidden' : '';
    document.documentElement.style.overflow = val;
    document.body.style.overflow = val;
    return () => {
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    };
  }, [lightbox]);

  // Keyboard: Escape closes, arrows navigate
  useEffect(() => {
    if (lightbox === null) return;
    const onKey = (e) => {
      if (e.key === 'Escape')     setLightbox(null);
      if (e.key === 'ArrowLeft')  setLightbox(i => (i === 0 ? filteredPhotos.length - 1 : i - 1));
      if (e.key === 'ArrowRight') setLightbox(i => (i === filteredPhotos.length - 1 ? 0 : i + 1));
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [lightbox, filteredPhotos.length]);

  // Keep the active thumbnail centred in the filmstrip
  useEffect(() => {
    if (lightbox === null || !thumbStripRef.current) return;
    const strip = thumbStripRef.current;
    const thumb = strip.children[lightbox];
    if (!thumb) return;
    strip.scrollLeft = thumb.offsetLeft - strip.offsetWidth / 2 + thumb.offsetWidth / 2;
  }, [lightbox]);

  const closeLightbox = () => setLightbox(null);
  const prev = () => setLightbox(i => (i === 0 ? filteredPhotos.length - 1 : i - 1));
  const next = () => setLightbox(i => (i === filteredPhotos.length - 1 ? 0 : i + 1));

  // Swipe: record start position, navigate on release if swipe > 50px
  const onTouchStart = (e) => { touchStartX.current = e.touches[0].clientX; };
  const onTouchEnd   = (e) => {
    if (touchStartX.current === null) return;
    const dx = touchStartX.current - e.changedTouches[0].clientX;
    if (Math.abs(dx) > 50) dx > 0 ? next() : prev();
    touchStartX.current = null;
  };

  // Render the lightbox via portal so position:fixed escapes the
  // page-enter transform (transforms create a new stacking context
  // that breaks fixed positioning for all descendants).
  const lightboxPortal = lightbox !== null ? createPortal(
    <div
      className="lightbox"
      onClick={closeLightbox}
      onTouchStart={onTouchStart}
      onTouchEnd={onTouchEnd}
    >
      {/* Top bar: image counter + close button */}
      <div className="lightbox-topbar" onClick={e => e.stopPropagation()}>
        <span className="lightbox-counter">
          {lightbox + 1}<span className="lightbox-counter-sep"> / </span>{filteredPhotos.length}
        </span>
        <button className="lightbox-close" onClick={closeLightbox} aria-label="Close viewer">✕</button>
      </div>

      {/* Left arrow */}
      <button
        className="lightbox-arrow lightbox-arrow--prev"
        onClick={e => { e.stopPropagation(); prev(); }}
        aria-label="Previous image"
      >‹</button>

      {/* Main image — key change remounts element, triggering fade-in animation */}
      <img
        key={lightbox}
        src={filteredPhotos[lightbox].src}
        alt={filteredPhotos[lightbox].alt}
        className="lightbox-main-img"
        loading="lazy"
        onClick={e => e.stopPropagation()}
      />

      {/* Right arrow */}
      <button
        className="lightbox-arrow lightbox-arrow--next"
        onClick={e => { e.stopPropagation(); next(); }}
        aria-label="Next image"
      >›</button>

      {/* Floating filmstrip — horizontally scrollable, auto-centred on active thumb */}
      <div className="lightbox-filmstrip" onClick={e => e.stopPropagation()}>
        <div className="lightbox-thumbs" ref={thumbStripRef}>
          {filteredPhotos.map((photo, i) => (
            <button
              key={photo.src}
              className={`lightbox-thumb${i === lightbox ? ' lightbox-thumb--active' : ''}`}
              onClick={() => setLightbox(i)}
              aria-label={`View ${photo.title}`}
            >
              <img src={photo.thumb} alt="" loading="lazy" />
            </button>
          ))}
        </div>
      </div>
    </div>,
    document.body
  ) : null;

  return (
    <>
    <div className="page gallery-page">
      <PageHero title="Gallery" image={FlagStreet} />

      <div className="page-inner gallery-inner">

        {/* Category filter bar — centered, underline active state */}
        <nav className="gallery-filter-bar" aria-label="Filter gallery by category">
          {CATEGORIES.map(cat => (
            <button
              key={cat}
              className={`gallery-filter-btn${activeCategory === cat ? ' gallery-filter-btn--active' : ''}`}
              onClick={() => { setActiveCategory(cat); setLightbox(null); }}
              aria-pressed={activeCategory === cat}
            >
              {cat}
            </button>
          ))}
        </nav>

        {/* Thin separator below the filter bar */}
        <div className="gallery-filter-divider" aria-hidden="true" />

        {/* Photo grid — 3-col desktop · 2-col tablet · 1-col mobile */}
        <div className="gallery-grid">
          {filteredPhotos.map((photo, index) => (
            <div key={photo.src} className="gallery-item">
              <button
                className="gallery-img-wrap"
                onClick={() => setLightbox(index)}
                aria-label={`View ${photo.title}`}
              >
                <img src={photo.thumb} alt={photo.alt} loading="lazy" />
              </button>
              <div className="gallery-caption">
                <span className="gallery-caption-category">{photo.category}</span>
                <span className="gallery-caption-title">{photo.title}</span>
              </div>
            </div>
          ))}
        </div>

      </div>

    </div>
    {lightboxPortal}
    </>
  );
};

export default Gallery;
